import * as angular from 'angular';
import Subscription from "./subscription";
import SubscriptionService from "./subscription.service";

export default angular.module('CrazyWeb.Plans.Subscription', [])
    .component("subscription", Subscription)
    .service("Subscription", SubscriptionService).name
